export default __webpack_public_path__ + "static/media/0x0b313b4c589a3bd3350f625f2e94dc80ab50017e.109d4dc8.webp";